import { render, staticRenderFns } from "./Sos.html?vue&type=template&id=4de86b81&scoped=true&external"
import script from "./Sos.js?vue&type=script&lang=js&external"
export * from "./Sos.js?vue&type=script&lang=js&external"
import style0 from "./Sos.vue?vue&type=style&index=0&id=4de86b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de86b81",
  null
  
)

export default component.exports